import { cn } from "../../../lib/utils";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../ui/select";

export function DropdownField({
  item,
  value,
  error,
  helperText,
  disabled,
  onValueChange,
  className,
}) {
  const options = item?.options ?? item?.values ?? [];
  const placeholder = item?.placeholder || "Select an option";

  return (
    <div className="space-y-2">
      <Select
        value={value != null ? String(value) : ""}
        onValueChange={onValueChange}
        disabled={item?.disabled || disabled}
      >
        <SelectTrigger
          id={item?.pathToValue}
          className={cn(
            "w-full",
            error ? "border-red-500 hover:border-red-500 focus:border-red-500" : "border-gray-300",
            className
          )}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>

        {/* Open below the trigger, aligned to start to match design */}
        <SelectContent position="popper" side="bottom" align="start">
          {options.map((opt, idx) => {
            const val =
              typeof opt === "object" ? String(opt.value ?? "") : String(opt);
            const label =
              typeof opt === "object"
                ? String(opt.label ?? opt.value ?? "")
                : String(opt);
            return (
              <SelectItem key={opt?.value ?? idx} value={val}>
                {label}
              </SelectItem>
            );
          })}
        </SelectContent>
      </Select>
    </div>
  );
}
